<template>
  <Multiselect
              :class="{'multiselect-sm': small}"
               class=""
               v-model="vModel"
              :disabled="disabled"
               :options="filteredGroups"
               :custom-label="(opt) => `${opt.name} - ${opt.type}`"
               track-by="id"
               select-label="Select"
               :placeholder="multiple ? helper.trans('labels.traffic_groups') : helper.trans('labels.traffic_group')"
               open-direction="bottom"
               :multiple="multiple"
               :searchable="true"
               :internal-search="true"
               :clear-on-select="!multiple"
               :close-on-select="!multiple"
               :options-limit="100"
               :limit="1000"
               :show-no-results="false"
               :hide-selected="multiple"
  >
  </Multiselect>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType} from 'vue'
import {debounce, helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {numberFormatter} from "@/service/NumberFormatter";
import Multiselect from "vue-multiselect";
import APIClient from "@/service/APIClient";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import {Direction} from "@/models/enum/Direction";

const api = new APIClient()

export default defineComponent({
  name: 'TrafficGroupMultiselect',
  emits: ['update:modelValue'],
  components: {
    Multiselect
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    } as Prop<boolean>,
    multiple: {
      type: Boolean,
      default: false
    } as Prop<boolean>,
    small: {
      type: Boolean,
      default: false
    } as Prop<boolean>,
    modelValue: {
      type: Object as PropType<any>,
      default: null
    } as Prop<any>,
    direction: {
      type: String as PropType<Direction | null>,
      default: null
    } as Prop<Direction | null>,
  },
  setup(props, {emit}) {

    const state = reactive({
      groups: [] as TrafficGroupDTO[]
    })

    const filteredGroups = computed((): TrafficGroupDTO[] => {
      return props.direction === null ? state.groups : state.groups.filter(group => group.type === props.direction)
    })

    const vModel = computed({
      get(): any {
        return props.modelValue
      },
      set(value: any): void {
        emit('update:modelValue', value);
      },
    });

    onMounted(async () => {
      state.groups = await api.call.trafficGroups.all()
    });

    return {
      ...toRefs(state),
      filteredGroups,
      vModel,
      helper,
      numberFormatter
    }
  }
})
</script>
